import styled from 'styled-components'

import { ITypography } from './globals.interfaces'

export const Typography = styled.p<ITypography>`
  font-family: ${(props) => props.fontFamily};
  color: ${(props) => props.color};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  align-self: ${(props) => props.alignSelf};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  font-style: ${(props) => props.fontStyle};
  text-decoration: ${(props) => props.textDecoration};
  line-height: ${(props) => props.lineHeight};
  letter-spacing: ${(props) => props.letterSpacing};
  word-spacing: ${(props) => props.wordSpacing};
  padding: ${(props) => props.padding};
  padding-top: ${(props) => props.paddingTop || props.paddingY};
  padding-bottom: ${(props) => props.paddingBottom || props.paddingY};
  padding-right: ${(props) => props.paddingRight || props.paddingX};
  padding-left: ${(props) => props.paddingLeft || props.paddingX};
  flex: ${(props) => props.flex};
  width: ${(props) => props.width};
`
